import React from 'react';
import { useDispatch } from 'react-redux';
import { loadFormDefinition } from '@redux/modules/formGeneration';

import Carousel from 'react-bootstrap/Carousel';
import Button from '@components/smartAdminUI/Button';

import ResidentialImage from '@images/createListing/residential.jpg';
import MultiImage from '@images/createListing/multi.jpg';
import MobileImage from '@images/createListing/mobile.jpg';
import LandImage from '@images/createListing/land.jpg';
import CommercialImage from '@images/createListing/commercial.jpg';
import FarmImage from '@images/createListing/farm.jpg';
import RentImage from '@images/createListing/rent.jpg';

const CreateListingWidget = () => {
  const dispatch = useDispatch();
  const handleClicked = e => {
    e.stopPropagation();
    const clickedItem = e?.currentTarget?.dataset?.id;
    if (clickedItem) {
      const [operationType, definitionType, listingType] = clickedItem.split('-');
      dispatch(loadFormDefinition(operationType, definitionType, listingType, null, 'listing'));
    }
  };
  return (
    <>
      <Carousel fade>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={ResidentialImage}
            alt="Residential"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Residential</h3>
            <p className="fs-md">A property that is owned for people to live in. This includes detached, semi-detached, row and condominium properties</p>
            <Button
              name="btnCreateResidentialListing"
              variant="primary"
              data-id="create-listings-res"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={MultiImage}
            alt="Multi-Family"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Multi-Family</h3>
            <p className="fs-md">A listing where 2 - 4 units are being sold together, regardless of whether they are connected.</p>
            <Button
              name="btnCreateMultiFamilyListing"
              variant="primary btn-sm"
              data-id="create-listings-mult"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={RentImage}
            alt="Rental"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Rental</h3>
            <p className="fs-md">Residential properties listed for rent or lease. This includes all residential property sub-types. </p>
            <Button
              name="btnCreateRentalListing"
              variant="primary btn-sm"
              data-id="create-listings-rnt"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={MobileImage}
            alt="Mobile"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Mobile</h3>
            <p className="fs-md">Mobile home on rented/leased land. Note: If a mobile home includes land with the sale it should be listed under detached residential</p>
            <Button
              name="btnCreateMobileListing"
              variant="primary btn-sm"
              data-id="create-listings-mob"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={LandImage}
            alt="Land"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Land</h3>
            <p className="fs-md">A property that does not have a dwelling on it, including rural acreage parcels and vacant residential lots. Should include all land parcels regardless of their zoning</p>
            <Button
              name="btnCreateLandListing"
              variant="primary btn-sm"
              data-id="create-listings-land"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={CommercialImage}
            alt="Commercial"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Commercial</h3>
            <p className="fs-md">Office, industrial, retail property and multi-family with 5 or more units being sold in a single transaction</p>
            <Button
              name="btnCreateCommercialListing"
              variant="primary btn-sm"
              data-id="create-listings-com"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={FarmImage}
            alt="Agribusiness"
          />
          <Carousel.Caption>
            <h3 className="fs-xxl">Agribusiness</h3>
            <p className="fs-md">A property where the primary purpose is agricultural</p>
            <Button
              name="btnCreateAgribusinessListing"
              variant="primary btn-sm"
              data-id="create-listings-farm"
              onClick={handleClicked}
            >
              <i className="fas fa-plus mr-2" aria-hidden="true" />
              Create
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </>
  );
};

export default CreateListingWidget;
